<div class="outer-div">
  <div class="inner-div">
    <!--    Form Section starts  -->
    <div class="form-section">
      <div class="inner-form-div">
        <section class="logo-section">
          <img src="\assets\Images\Logo\RajguruLogo.png" />
        </section>
        <section><h1>Welcome To RajGuru</h1></section>
        <section><h3>Login</h3></section>
        <section>
          <!--    Signup Form starts  -->
          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <mat-form-field appearance="outline" color="accent">
              <mat-label>Email</mat-label>
              <input
                type="email"
                matInput
                formControlName="email"
                placeholder="Email"
              />
              <mat-icon color="primary" matSuffix>email</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline" color="accent">
              <mat-label>Password</mat-label>
              <input
                matInput
                formControlName="password"
                placeholder="Password"
                [type]="passwordType"
              />
              <mat-icon
                matSuffix
                (click)="showPasswordType()"
                *ngIf="passwordType === 'password'"
              >
                lock
              </mat-icon>
              <mat-icon
                matSuffix
                (click)="showPasswordType()"
                *ngIf="passwordType === 'text'"
              >
                lock_open
              </mat-icon>
            </mat-form-field>

            <section>
              <p>
                Don't have an account ?
                <a routerLink="/sign-up">Register Now</a>
              </p>
            </section>
            <section>
              <p><a routerLink="/forgot-password">Forgot Password ?</a></p>
            </section>
            <section>
              <button
                [disabled]="loginForm.invalid"
                color="primary"
                type="submit"
                mat-raised-button
              >
                Continue
              </button>
            </section>
          </form>
          <!--    Signup Form ends  -->
        </section>
      </div>
    </div>
  </div>
</div>
